import React from 'react'
import { Link } from 'react-router-dom'
import { FaPlusSquare } from 'react-icons/fa'
const Box = ({ icon, title, serviceId }) => {
  return (
    <Link
      to={`/single-service/${serviceId}`}
      onClick={() => localStorage.setItem('serviceLawyer', serviceId)}
      className={`service-link-box`}
    >
      <div>{icon}</div>
      <div className='title'>{title}</div>
      <div className='choose'>
        <FaPlusSquare /> <span>انتخاب کنید</span>
      </div>
    </Link>
  )
}
export default Box
